/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The source of schema.
 */
export type DraftCreateMetaSchema =
    | Truvity.MetaSchema
    /**
     * The URL to the meta schema. */
    | string;
